<template>
  <div class="list-container">
    <nav v-if="orderBy.length > 0" class="sort">
      <context-menu class="menu" :displayed="displayedData" position="bottom-right" @close="close">
        <button slot="anchor" type="button" class="flat icon before" :class="buttonSize" @click="displayedData = !displayedData">
          <svgicon name="filter" :alt="$t('filter')" />
          <span>{{ currentOrder.orderLabel }} {{ currentOrder.label }}</span>
        </button>
        <ul slot="content">
          <li v-for="(order, index) in orderBy" :key="index" class="content-item" @click="optionSelected(order, index)">
            <a href="#" :class="{ active: currentOrder === order }">{{ order.label }}</a>
          </li>
        </ul>
      </context-menu>
      <p v-if="visibleListItems.length >= 2" class="subtle small result">
        <span>{{ visibleListItems.length }}&nbsp;</span>
        <span v-t>Results</span>
      </p>
      <p v-if="visibleListItems.length < 2" class="subtle small result">
        <span>{{ visibleListItems.length }}&nbsp;</span>
        <span v-t>Result</span>
      </p>
    </nav>
    <slot name="header-labels" :order="currentOrder" />
    <ul class="list-component">
      <slot v-for="item in visibleListItems" name="listItem" :value="item" />
    </ul>
  </div>
</template>

<script>
import '@/lib/icons/filter';
import contextMenu from './context_menu';

function sortList(list, sortBy, dataType) {
  function compare(x, y) {
    // null sorted to the end of the list if sorting by firstName or lastName
    if ((sortBy.toLowerCase().includes('name')) && x[sortBy] === null) {
      return 1;
    } if ((sortBy.toLowerCase().includes('name')) && x[sortBy] != null && y[sortBy] === null) {
      return -1;
    }
    return x[sortBy].toLowerCase() < y[sortBy].toLowerCase() ? -1 : 1;
  }
  if (typeof sortBy === 'string') {
    if (dataType === 'string') {
      list.sort(compare);
    } else {
      list.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
    }
  }
  return list;
}

function sortAndFilter(completeList, {
  sortBy, asc = true, filter = () => true, dataType,
}) {
  const filteredList = completeList.filter(filter);
  const sortedList = sortList(filteredList, sortBy, dataType);
  if (asc === false) sortedList.reverse();
  return sortedList;
}

export default {
  name: 'List',
  components: { 'context-menu': contextMenu },
  props: {
    orderBy: {
      type: Array,
      default: () => [],
    },
    defaultOrder: {
      type: Number,
      default: 0,
    },
    position: {
      type: String,
      default: 'bottom-right',
    },
    listItems: {
      type: Array,
      default: () => [],
    },
    buttonSize: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      currentOrder: this.orderBy.length > 0 ? this.orderBy[this.defaultOrder] : null,
      displayedData: false,
      selectedOption: this.defaultOrder,
    };
  },
  computed: {
    visibleListItems() {
      if (this.currentOrder) return sortAndFilter(this.listItems, this.currentOrder);
      return this.listItems;
    },
  },
  watch: {
    orderBy(updatedOrderByValue) {
      this.currentOrder = updatedOrderByValue[this.selectedOption];
    },
  },
  methods: {
    close() {
      this.displayedData = false;
    },

    optionSelected(order, index) {
      this.currentOrder = order;
      this.selectedOption = index;
      this.$emit('optionSelected', order);
      this.close();
    },
  },
};

</script>

<style lang="scss" scoped>
  .desktop {
    display: none;
    @media #{$screen-width-small} { display: block; }
  }

  .list-container {
    width: 100%;
  }

  .sort {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 1rem;
    padding: 0;
    @media #{$screen-width-medium} { padding: 0 .75rem; }

    .result {
      margin: 0;
    }
  }

  .header-labels {
    @media #{$screen-width-medium} { padding: 0 .75rem; }
  }

  .sort > .menu > a > span {
    &::before {
      content: '';
      margin-left: 0.25rem;
    }
  }

  .content-item {
    color: $primary-500;

      &:hover, &:focus {
        background: $primary-50;
        color: $primary-500;
      }
  }

  .list-component {
    display: block;
    margin: 0 1rem 5rem 1rem;
    > li {
      margin: 0;
      border-top: 1px solid $pearl-300;
    }
    a {
      transition: none;
      justify-content: space-between;
      display: flex;
      width: 100%;
      text-decoration: none;
      color: $black;
      padding: 0.75rem 0;
      &:hover, &:focus, &.router-link-active {
        background: $primary-50;
        color: $primary-500;
      }
      @media #{$screen-width-medium} {
        padding: 0.75rem;
      }
    }
  }

  ul {
    margin: 0.5rem 0;
  }

</style>
